module.exports = __webpack_public_path__ + "static/media/active-process.68d3c478.svg";